import { useEffect, useMemo, useState } from 'react';

import { UserQuestion01Icon } from '@hugeicons/core-free-icons';
import { Controller } from 'react-hook-form';

import { InputGroup, MultipleSelect, ToggleSwitchInput } from 'components/FormComponents';

export const CandidateQuestionnaireSelectorDetails = ({
  index,
  append,
  remove,
  control,
  watch,
  credits = 0,
  candidateForms,
}) => {
  const [enabled, setEnabled] = useState(false);

  const formValue = watch(`checks.${index}.details.form_ids`);

  useEffect(() => {
    if (enabled && isNaN(index)) {
      append({
        type: 'candidate_questionnaire',
        details: {},
      });
    } else if (!enabled && index >= 0) {
      remove(index);
    }
  }, [enabled]);

  useEffect(() => {
    if (index >= 0 && !enabled) setEnabled(true);
    else if (isNaN(index) && enabled) setEnabled(false);
  }, [index]);

  return (
    <ToggleSwitchInput
      text="Candidate Questionnaire"
      logo="https://checkmate-prod.s3.ap-southeast-2.amazonaws.com/assets/checkmate_check_logo.svg"
      className={credits === 0 ? 'u-border-error u-disabled' : ''}
      subtext={(credits < 0 ? 'Unlimited' : credits) + ' remaining'}
      onChange={e => setEnabled(e.target.checked)}
      dataTestId="toggle-switch-questionnaire"
      icon={UserQuestion01Icon}
      value={enabled}>
      {enabled && index >= 0 && (
        <InputGroup title="Form">
          <Controller
            control={control}
            name={`checks.${index}.details.form_ids`}
            placeholder="Select..."
            render={({ field: { onChange, value } }) => (
              <MultipleSelect value={value} onChange={onChange} placeholder="Select...">
                {candidateForms.map(form => (
                  <MultipleSelect.Item
                    key={form.id}
                    value={form.id}
                    active={formValue?.includes(form.id)}>
                    {form.name}
                  </MultipleSelect.Item>
                ))}
              </MultipleSelect>
            )}
          />
        </InputGroup>
      )}
    </ToggleSwitchInput>
  );
};
